import React, { Component, forwardRef } from "react";
import { Link } from "react-router-dom";
import CatLoading from "./catloading";

class CategoryBase extends Component {
  data = this.props.Data;
  language = this.props.Language;

  render() {
    return (
      <Link
        to={"/menu/" + this.data.id}
        className={`categories-item ${this.props.Active ? "active" : ""}`}
        onClick={() => this.props.handleCategory(this.data.id)}
        ref={this.props.forwardedRef} // <- we pass ref to DOM element
      >
        <span className="categories-name">
          {this.props.Language === "en"
            ? this.data.name_eng
            : this.props.Language === "krd"
            ? this.data.name_krd
            : this.data.name_ar}
        </span>
      </Link>
    );
  }
}

// Wrap it in forwardRef to expose the ref to parent
const Category = forwardRef((props, ref) => {
  return <CategoryBase {...props} forwardedRef={ref} />;
});

export default Category;
